/** @jsxImportSource solid-js */
import { type JSX } from "solid-js";
import { WidgetIsland } from "./widget-island";
import { WidgetPins } from "./widget-pins";
import { WidgetScrim } from "./widget-scrim";
import { WidgetToast } from "./widget-toast";

export function WidgetRoot(): JSX.Element {
  return (
    <>
      <WidgetScrim />
      <WidgetPins />
      <WidgetIsland />
      <WidgetToast />
    </>
  );
}
